import { render, staticRenderFns } from "./LocationTab.vue?vue&type=template&id=6208ee55&scoped=true"
import script from "./LocationTab.vue?vue&type=script&lang=js"
export * from "./LocationTab.vue?vue&type=script&lang=js"
import style0 from "./LocationTab.vue?vue&type=style&index=0&id=6208ee55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6208ee55",
  null
  
)

export default component.exports